<div class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="EditMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title mb-0" id="EditMemberLabel">{{title}}</h2>
        <a class="btn btn-close" aria-label="Close" (click)="cancel()"></a>
      </div>

      @if (member) {
        <div class="modal-body">
          <!-- Member Info (read-only) -->
          <div class="d-flex align-items-center gap-3 mb-4 pb-3 border-bottom">
            <img [src]="member.picture" style="width: 48px; height: 48px" class="rounded-circle border border-dark">
            <div>
              <div class="text-muted">{{member.email}}</div>
            </div>
          </div>

          <!-- Editable Fields -->
          <form [formGroup]="form" class="d-grid gap-3">
            <div>
              <label for="memberName" class="form-label">Name</label>
              <input type="text" class="form-control" id="memberName" formControlName="name"
                placeholder="e.g. John Smith" maxlength="50">
            </div>

            <div>
              <label for="employeeNumber" class="form-label">Employee Number</label>
              <input type="text" class="form-control" id="employeeNumber" formControlName="employeeNumber"
                placeholder="e.g. EMP-001" maxlength="50">
              <div class="form-text">Optional identifier used in work orders and reports.</div>
            </div>

            <div>
              <label for="memberRole" class="form-label">Role</label>
              <select class="form-select" id="memberRole" formControlName="role">
                @for (role of organizationRoles; track role.id) {
                  <option [value]="role.id">
                    {{role.name | titlecase}}
                    ({{seatLabel(role.id)}})
                  </option>
                }
              </select>
            </div>
          </form>
        </div>
      }

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!member || !canSaveRole">Save</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
